import React from 'react';
import { findIndex } from 'lodash';

import {
  Modal,
  Button,
  FormControl,
  FormGroup,
  ControlLabel,
  Col,
  Row,
  Well
} from 'react-bootstrap';


import { DataListWrapper } from '../../../commonComponents/DataTable/DataTablePs';
import TitleRow from '../../../commonComponents/TitleRow';

import custJqAjax from '../../../commonJS/custJqAjax';
// import autoFill from '../../../commonJS/autoFill';
import parentStateHandler from '../../../commonJS/parentStateHandler';
import { textInputOnChange, dropDownOnChange } from '../../../commonJS/onFormChanges';
import inputValidation from '../../../commonJS/inputValidation';
import autoFill from '../../../commonJS/autoFill';


export default class CompanyIntroductionModalCt extends React.Component {
  constructor(props) {
    super(props);
    this.handlers = {
      onInputFocus: e => {
        autoFill(e, this);
      },
      textInputOnChange: e => {
        textInputOnChange(e, this);
      },
      dropDownOnChange: (selection, stateName) => {
        const obj = dropDownOnChange(selection, stateName);

        this.setState(obj);
      },
      // onInputFocus: e => {
      //   autoFill(e, this);
      // },
      saveItem: isUpdate => {
        const state = this.state,
          props = this.props;
        // id = isUpdate ? (props.selectedItemId || props.params.itemId) : "";
        // ja_data_list = `${state.price_ja}|${state.delivery_ja}|${state.characteristics_ja}|${state.appliance_ja}`; 

        let formData = new FormData();

        formData.append('user_account', state.userAccount);
        formData.append('user_name', state.userName);
        formData.append('group_id', state.groupId);
        formData.append('role_id', state.roleId);
        formData.append('role_list', '0');
        formData.append('emp_id', state.empId);
        formData.append('email', state.email);
        formData.append('job_title', state.jobTitle);
        formData.append('mobile_phone', state.mobilePhone1);
        formData.append('mobile_phone2', state.mobilePhone2);
        formData.append('tel', state.tel);
        formData.append('ext', state.ext);
        formData.append('fax', state.fax);
        formData.append('is_admin', state.isAdmin);
        formData.append('agent_id', state.agentId);
        formData.append('is_display', state.isDisplay);
        formData.append('is_fix_user', state.isFixUser);
        formData.append('enabled', state.enabled);

        // update時密碼非必填
        if (isUpdate) {
          if (state.userPwd) {
            formData.append('user_passwd', state.userPwd);
            formData.append('check_passwd', state.checkPwd);
          }
        } else {
          formData.append('user_passwd', state.userPwd);
          formData.append('check_passwd', state.checkPwd);
        }

        // 特別處理 for api 用delete api做修改啟用不啟用的變更…

        const cb = () => {
          custJqAjax({
            type: 'POST',
            url: `/api/W_ManageAccount_${isUpdate ? 'Update' : 'Post'}.php`,
            data: formData,
            processData: false,
            contentType: false,
            success: res => {
              const resId = res.result[0].user_account;

              this.handlers.onItemModified(res.result[0], isUpdate ? 'update' : 'create');

              // 指定的是item id 而非file name, 有上傳時不需做刪除特定檔的動作
              if (!this.uploadedFiles[0]) {
                // 處理update的檔案刪除動作
                if (isUpdate) this.fileWorker(undefined, resId);
              }

              // 處理上傳檔案
              this.fileWorker(true, resId);

              // 如果完全沒有執行檔案相關作業，會需要從這裡關閉
              if (this.filesWip < 1) {
                props.closeModal();
              }

              // 更新搜尋結果
              props.parentStateHandler({ states: 'doSearchUpdate', newValues: 1 });
            }
          });
        };

        if (this.variables.enableDefaultState !== state.enabled) {
          this.handlers.deleteItem(cb);
        } else {
          cb();
        }

      },
      deleteItem: (cb) => {
        let formData = new FormData(),
          id = this.props.selectedItemId;


        formData.append('user_account', id);

        custJqAjax({
          type: 'POST',
          url: '/api/W_ManageAccount_Delete.php',
          data: formData,
          processData: false,
          contentType: false,
          success: data => {
            if (cb) cb();
          }
        });
      },
      onItemModified: (data, mode) => {
        // 更新sortedData
        const itemId = data.user_account;
        let sortedData = this.props.sortedData,
          newItem = {
            ...data
          };

        if (this.uploadedFiles[0]) {
          newItem.img_path = this.uploadedFiles[0].preview;
        } else if (this.state.deletedDownloadedFiles[0]) {
          newItem.img_path = '';
        }

        if (mode === "create") {
          const len = sortedData._data.length;

          sortedData._data.push(newItem);
          // 新增的資料預設排在最前面
          sortedData._indexMap.unshift(len);
        } else if (mode === "update") {
          let updateInd = findIndex(sortedData._data, { user_account: itemId });
          sortedData._data[updateInd] = newItem;
        } else if (mode === "delete") {
          // let updateInd = findIndex(sortedData._data, {itemId: itemId});
          // 從indexMap中移除索引即可，不需從_data中移除資料
          // 確保為完整資料map而非搜尋篩選過的map
          // itemInd為刪除時會傳入的內容
          sortedData._data[data.itemInd].exception = true;
          const mapInd = sortedData._indexMap.indexOf(data.itemInd);
          sortedData._indexMap.splice(mapInd, 1);
        }

        // 雖然是相同的_data與_index資料，但owner 物件為新的，符合pure component需求
        sortedData = new DataListWrapper(sortedData._indexMap, sortedData._data);
        this.props.stateHandler({ states: 'userAccountSortedData', newValues: sortedData });
      },
      onEditClick: () => { this.setState({ onEdit: true, onCopy: false, editMode: "Edit" }) },
      onCopyClick: () => {
        // 重置
        // this.fileSorts = {
        //   img: [],
        //   pdf: [],
        //   video: []
        // };

        this.setState({
          // set mode
          onCopy: true, onEdit: false, editMode: "Copy",
          onPwdEdit: true,
          // clear itemId
          // itemId: '',
          // clear files
          downloadedFiles: [],
          downloadedImgs: [],
          downloadedPDFs: [],
          downloadedVideos: [],
          previewsImg: [],
          previewsPDF: [],
          previewsVideo: []
        }, () => {
          document.getElementById('userAccount').focus();
        });

      },
      loadItemData: () => {

        custJqAjax({
          type: 'GET',
          ajaxsWip: this.ajaxsWip,
          custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
          url: '/api/W_SaleSky_UserCompanyInfo_Lang_Get.php',
          processData: false,
          contentType: false,
          success: res => {
            if (!res.result.company_name) return;
            const data = res.result,
              filePath = data.img_path,
              orinFiles = [{ file_name: filePath, thumbnail: filePath }];

            const downloadedFiles = this.fileFilter(orinFiles);

            this.setState({
              userAccount: data.user_account,
              userName: data.user_name,
              groupId: data.user_group,
              roleId: data.role_id,
              empId: data.emp_id,
              email: data.email,
              jobTitle: data.job_title,
              mobilePhone1: data.mobile_phone,
              mobilePhone2: data.mobile_phone2,
              tel: data.tel,
              ext: data.ext,
              fax: data.fax,
              isAdmin: data.is_admin,
              agentId: data.agent_id,
              isDisplay: data.is_display,
              isFixUser: data.is_fix_user,
              enabled: data.enabled,
              onPwdEdit: false
            });

            // for downloaded files that uploaded before
            this.onFileDrop(downloadedFiles);
          }
        });
      }
    };

    this.variables = {
      companyName: ''
    };

    this.parentStateHandler = ({ states, newValues }) => {
      parentStateHandler({ states, newValues, parentThis: this });
    };

    this.ajaxsWip = [];


    // setTimeout Id
    this.timer = "";


    this.state = {
      // item ===
      title_tw: '',
      title_en: '',
      title_cn: '',
      title_ja: '',
      content_tw: '',
      content_en: '',
      content_cn: '',
      content_ja: '',
      // ===
      // common
      btnSaveDisable: true,
      btnDeleteDisable: true,
      onEdit: false,
      onCopy: false,
      editMode: "View"
    };
  }


  componentDidMount() {
    if (this.props.params && this.props.params.itemId) {
      this.handlers.loadItemData();
    } else {
      document.getElementById('title_tw').focus();
    }

  }

  componentDidUpdate(prevProps, prevState) {
    // 資料驗證ok才可送出
    if (
      !this.state.userName ||
      !this.state.groupId ||
      !this.state.roleId ||
      !inputValidation(this.state.userAccount, { emailTest: true }).emailTest ||
      !inputValidation(this.state.email, { emailTest: true }).emailTest ||
      (
        (
          !inputValidation(this.state.userPwd, { lengthTest: 6 }).lengthTest ||
          !inputValidation(this.state.checkPwd, { equalTest: this.state.userPwd }).equalTest
        ) && this.state.onPwdEdit
      )
    ) {

      if (!this.state.btnSaveDisable) this.setState({ btnSaveDisable: true });

    } else if (this.state.btnSaveDisable) {
      this.setState({ btnSaveDisable: false });
    }
  }

  componentWillUnmount() {
    this.props.propsPackageFromSkyFamily.ajaxAborter(this.ajaxsWip);
    clearTimeout(this.timer);
  }

  render() {
    const props = this.props,
      state = this.state,
      handlers = this.handlers;

    let saveBtn = "",
      editable = 0,
      modeBtns = "",
      itemId = "",
      saveBtnText = state.fileWorkInProgress ? '檔案上傳中...' : '儲存';

    if (props.params) itemId = props.params.itemId;
    // else  itemId = props.itemId;

    if (state.editMode !== "View" || !itemId) {
      saveBtn = (
        <Button disabled={state.btnSaveDisable}
          onClick={() => { handlers.saveItem(state.onEdit ? 1 : 0) }}
          style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>
          {saveBtnText}
        </Button>
      );
      editable = 1;
    } else {

      modeBtns = (
        <span>
          <Button
            onClick={handlers.onEditClick}
            style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>
            編輯
          </Button>
        </span>
      );

    }

    return (
      <Modal id="modal-product" keyboard={false} backdrop="static" show={true} onHide={props.closeModal} bsSize="large">
        <Modal.Header>
          <Modal.Title>
            <span style={{ padding: "6px 0px", height: 34, lineHeight: '34px' }}>
              {
                itemId ?
                  <span style={{ float: "left" }}>
                    <span style={{ color: "rgba(0, 0, 200, .7" }}>{state.editMode}</span> Mode
                </span> :
                  <span>
                    New Introduction
                </span>
              }
            </span>
            <Button onClick={props.closeModal} style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>取消</Button>
            {saveBtn}
            {modeBtns}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col sm={12}>
              <FormGroup controlId="companyName">
                <ControlLabel style={{ fontWeight: 'bold' }}>公司名稱</ControlLabel>
                <FormControl
                  disabled={true}
                  type='text'
                  value={this.variables.companyName}
                  style={{ height: 36 }} />
              </FormGroup>
            </Col>
          </Row>

          <TitleRow title="簡介抬頭" required={true} />

          <Well>
            <Row>

              <Col sm={6}>
                <FormGroup controlId="title_tw">
                  <ControlLabel>繁體中文</ControlLabel>
                  <FormControl
                    disabled={!editable}
                    type='text'
                    onFocus={handlers.onInputFocus}
                    onChange={handlers.textInputOnChange}
                    value={state.title_tw}
                    style={{ height: 36 }} />
                </FormGroup>
              </Col>
              <Col sm={6}>
                <FormGroup controlId="title_en">
                  <ControlLabel>英文</ControlLabel>
                  <FormControl
                    disabled={!editable}
                    onChange={handlers.textInputOnChange}
                    type='text'
                    onFocus={handlers.onInputFocus}
                    value={state.title_en}
                    style={{ height: 36 }} />
                </FormGroup>
              </Col>

              <Col sm={6}>
                <FormGroup controlId="title_cn">
                  <ControlLabel>簡體中文</ControlLabel>
                  <FormControl
                    disabled={!editable}
                    type='text'
                    onFocus={handlers.onInputFocus}
                    onChange={handlers.textInputOnChange}
                    value={state.title_cn}
                    style={{ height: 36 }} />
                </FormGroup>
              </Col>
              <Col sm={6}>
                <FormGroup controlId="title_ja">
                  <ControlLabel>日文</ControlLabel>
                  <FormControl
                    disabled={!editable}
                    onChange={handlers.textInputOnChange}
                    type='text'
                    onFocus={handlers.onInputFocus}
                    value={state.title_ja}
                    style={{ height: 36 }} />
                </FormGroup>
              </Col>

            </Row>
          </Well>

          <TitleRow title="簡介內容" required={true} />

          <Well>
            <Row>

              <Col sm={6}>
                <FormGroup controlId="content_tw">
                  <ControlLabel>繁體中文</ControlLabel>
                  <FormControl
                    onFocus={handlers.onInputFocus}
                    disabled={!editable}
                    value={state.content_tw}
                    onChange={handlers.textInputOnChange}
                    componentClass="textarea"
                    placeholder="Write descriptions here"
                    style={{ height: 200 }} />
                </FormGroup>
              </Col>

              <Col sm={6}>
                <FormGroup controlId="content_en">
                  <ControlLabel>英文</ControlLabel>
                  <FormControl
                    onFocus={handlers.onInputFocus}
                    disabled={!editable}
                    value={state.content_en}
                    onChange={handlers.textInputOnChange}
                    componentClass="textarea"
                    placeholder="Write descriptions here"
                    style={{ height: 200 }} />
                </FormGroup>
              </Col>

              <Col sm={6}>
                <FormGroup controlId="content_cn">
                  <ControlLabel>簡體中文</ControlLabel>
                  <FormControl
                    onFocus={handlers.onInputFocus}
                    disabled={!editable}
                    value={state.content_cn}
                    onChange={handlers.textInputOnChange}
                    componentClass="textarea"
                    placeholder="Write descriptions here"
                    style={{ height: 200 }} />
                </FormGroup>
              </Col>

              <Col sm={6}>
                <FormGroup controlId="content_ja">
                  <ControlLabel>日文</ControlLabel>
                  <FormControl
                    onFocus={handlers.onInputFocus}
                    disabled={!editable}
                    value={state.content_ja}
                    onChange={handlers.textInputOnChange}
                    componentClass="textarea"
                    placeholder="Write descriptions here"
                    style={{ height: 200 }} />
                </FormGroup>
              </Col>

            </Row>
          </Well>

          <TitleRow title="檔案上傳" />

          <Well style={{ marginBottom: 0 }}>
            <Row>

            </Row>
          </Well>

        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.closeModal} style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>取消</Button>
          {saveBtn}
        </Modal.Footer>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/salesky/routes/newAdmin/CompanyIntroductionModalCt.jsx